<template>
  <div class="item">
    <div class="item-pic">
      <div
        class="item-pic-core"
        :style="{ backgroundImage: 'url(' + $setPicSize(this.infoPic) + ')' }"
      />
    </div>
    <div class="item-info">
      <div class="item-info-result" :style="{ color: bagcolor }">{{ status }}</div>
      <div class="item-info-title">
        <span>{{ infoTitle }}</span>
      </div>
      <div class="item-info-price">
        <div v-if="price / 100 > 0">
          ￥<span>{{ price / 100 }}</span>
        </div>
      </div>
      <div class="item-info-time">{{ createTimes }}</div>
    </div>
    <div class="radio-btn" :class="{ active: selected }"></div>
  </div>
</template>

<script>
import setPicSize from '@zz-app/setPicSize'

export default {
  name: 'ListItem',
  data() {
    return {
      bagcolor: 'red'
    }
  },
  props: {
    infoTitle: {
      type: String,
      default: ''
    },
    orderId: {
      type: String,
      default: ''
    },
    infoPic: {
      type: String,
      default: ''
    },
    price: {
      type: String,
      default: '0'
    },
    createTime: {
      type: String,
      default: ''
    },
    selected: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: ''
    }
  },
  computed: {
    createTimes() {
      return this.createTime ? new Date(Number(this.createTime)).format('YYYY-MM-DD') : '' //  2018-02-21
    }
  },
  methods: {
    $setPicSize(url) {
      return setPicSize(url, 144, 144)
    }
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
